module.exports = __webpack_public_path__ + "img/charging-station.fee668cc.svg";